export const testimonials = [
  {
    name: 'Marcus T.',
    role: 'Sneaker Enthusiast',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20with%20clean%20minimalist%20style%2C%20warm%20neutral%20background%2C%20soft%20natural%20lighting%2C%20friendly%20expression%2C%20editorial%20portrait%20photography&width=120&height=120&seq=avatar-marcus&orientation=squarish',
    text: 'The most organized spreadsheet hub I have ever used. Updates are consistent and the categories make it incredibly easy to find exactly what I need for my next haul.',
    rating: 5,
  },
  {
    name: 'Sophie L.',
    role: 'Fashion Blogger',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20natural%20style%2C%20warm%20neutral%20background%2C%20soft%20natural%20lighting%2C%20confident%20expression%2C%20editorial%20portrait%20photography&width=120&height=120&seq=avatar-sophie&orientation=squarish',
    text: 'I switched from random Reddit threads to this curated list and never looked back. The fashion category has saved me countless hours of searching through unverified links.',
    rating: 5,
  },
  {
    name: 'David K.',
    role: 'Budget Shopper',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20man%20with%20casual%20minimalist%20style%2C%20warm%20neutral%20background%2C%20soft%20natural%20lighting%2C%20approachable%20expression%2C%20editorial%20portrait%20photography&width=120&height=120&seq=avatar-david&orientation=squarish',
    text: 'As someone new to agent shopping, the beginner-friendly guides and organized spreadsheets were a game changer. Finally found reliable sources without the guesswork.',
    rating: 5,
  },
  {
    name: 'Emma R.',
    role: 'Reseller',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20modern%20style%2C%20warm%20neutral%20background%2C%20soft%20natural%20lighting%2C%20professional%20expression%2C%20editorial%20portrait%20photography&width=120&height=120&seq=avatar-emma&orientation=squarish',
    text: 'The daily updates are no joke. I rely on these spreadsheets for my reselling business and the accuracy rate is impressive. Highly recommend the sneaker category.',
    rating: 5,
  },
  {
    name: 'James W.',
    role: 'Streetwear Collector',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20man%20with%20stylish%20minimalist%20look%2C%20warm%20neutral%20background%2C%20soft%20natural%20lighting%2C%20cool%20expression%2C%20editorial%20portrait%20photography&width=120&height=120&seq=avatar-james&orientation=squarish',
    text: 'Finally a spreadsheet hub that actually updates. Most lists online are months old with dead links. This one stays fresh and the quality control is evident in every category.',
    rating: 5,
  },
  {
    name: 'Olivia M.',
    role: 'Lifestyle Creator',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20elegant%20minimalist%20style%2C%20warm%20neutral%20background%2C%20soft%20natural%20lighting%2C%20warm%20expression%2C%20editorial%20portrait%20photography&width=120&height=120&seq=avatar-olivia&orientation=squarish',
    text: 'The accessories and bags categories are absolute gold. I have found pieces that my followers love and the price comparisons help me make smarter buying decisions.',
    rating: 5,
  },
];